import { useAnalyticsTracking } from '@/analytics/snowplow/AnalyticsTrackingContext';
import { useEmitUiEvent } from '@/analytics/snowplow/useEmitUIEvent';
import { useAppStore, usePrescriptionDispenseLimitExceeded } from '@/state-management';
import { useCallback, useRef } from 'react';

export const useDispenseLimitAnalytics = () => {
  const emitEvent = useEmitUiEvent();
  const hasEmittedInitialEvent = useRef(false);
  const {
    prescriptionPad: { medicationPadItems },
  } = useAppStore.use.prescriptionAssistant();

  const { totalGrams } = usePrescriptionDispenseLimitExceeded();
  const { uiEvent } = useAnalyticsTracking();

  const trackDispenseLimitEvent = useCallback(() => {
    const productIds = (medicationPadItems ?? [])
      .map((item) => String(item.medicationPadItem?.productId))
      .filter((id): id is string => typeof id === 'string');

    const prescriptionAttributes = [
      {
        name: 'product_id',
        value: productIds,
      },
      {
        name: 'total_quantity',
        value: String(totalGrams),
      },
      {
        name: 'unit',
        value: 'g',
      },
    ];

    if (!hasEmittedInitialEvent.current) {
      emitEvent(
        {
          component_name: 'DispenseLimitNotification',
          event_name: 'popup_dispense_limit_notification',
          id: 'dispensing_limit_exceeded',
          context_id: uiEvent?.context_id,
        },
        {
          prescriptionProduct: {
            attributes: prescriptionAttributes,
          },
        },
      );
      hasEmittedInitialEvent.current = true;
    }
  }, [emitEvent, medicationPadItems, totalGrams, uiEvent]);

  const resetTracking = useCallback(() => {
    hasEmittedInitialEvent.current = false;
  }, []);

  return { trackDispenseLimitEvent, resetTracking };
};
